export default __webpack_public_path__ + "static/media/rulesBgDec2.5866c1dd.png";